import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify, {
  VAlert,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VToolbar,
  VDataTable,
  VProgressLinear
} from 'vuetify/lib'

// vue-cli a-la-carte installation
Vue.use(Vuetify, {
  components: {
    VAlert,
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VToolbar,
    VDataTable,
    VProgressLinear
  }
})

const opts = {
    theme: {
        options: { customProperties: true },
    themes: {
      light: {
        primary: '#252dcf',
        secondary: '#00856c',
        accent: '#9148b8',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        grey: '#808080',
        white: '#FFFFFF',
        lightpurple: '#A8ABED'
      }
      // dark: {
      // }
    }
  }
}

export default new Vuetify(opts)
